import CONSTANTS from "@/constants/index"

const validNumber = text => {
  const validRegex = CONSTANTS?.REGEX_NUMBER
  return validRegex.test(text)
}

const validPhone = text => {
  const validRegex = CONSTANTS?.REGEX_PHONE_NUMBER
  return validRegex.test(text)
}

const validText = text => {
  const validRegex = CONSTANTS?.REGEX_USER_TEXT
  return validRegex.test(text)
}

const validateEmail = email => {
  if (CONSTANTS.REGEX_EMAIL.test(email)) return true
  return false
}

const validateOptionalEmail = email => {  
  if (CONSTANTS.REGEX_EMAIL_OPTIONAL.test(email)) return true
  return false
}

const validPincode = pinCode => {
  return (CONSTANTS.REGEX_PINCODE.test(pinCode)) ? true : false 
}

const validateNoOfBathroom_optional = item => {
  return (CONSTANTS.REGEX_NO_OF_BATHROOM_OPTIONAL.test(item)) ? true : false
} 

const validateNoOfBathroom_mandatroy = item => {
  return (CONSTANTS.REGEX_NO_OF_BATHROOM_MANDATORY.test(item)) ? true : false
} 

export { validNumber, validText, validateEmail, validPincode, validPhone, validateOptionalEmail, validateNoOfBathroom_mandatroy, validateNoOfBathroom_optional }
